module.exports = __webpack_public_path__ + "img/成果展示banner.0898de88.png";